module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fcee2fa04b9ae2811c2bd347df8def5e.png";